export enum SelectedDiscount {
  PROMOCODE = 'promocode',
  BONUSES = 'bonuses',
}

export enum BasketPurchaseButtonEmit {
  'goToAddress' = 'goToAddress',
  'goToCatalog' = 'goToCatalog',
  'goToPayment' = 'goToPayment',
  'goToPurchase' = 'goToPurchase',
  'goToAuthorize' = 'goToAuthorize',
  'goToDeliveryAt' = 'goToDeliveryAt',
  'goToDiscount' = 'goToDiscount',
  'goToGifts' = 'goToGifts',
}

export enum CheckoutButtonState {
  changeExchange = 'Изменить сдачу',
}

export type CheckoutButtonStateType = CheckoutButtonState | null

export type CheckoutButtonStateInjectType = {
  get: Ref<CheckoutButtonStateType>
  set: (value: CheckoutButtonStateType) => void
}
